// stores/baseCrudStore.ts
import adminAxios from '@/plugins/axios';

export function createCrudActions(baseUrl) {
  return {
    async all(params = {}) {
      try {
        const response = await adminAxios.get(`${baseUrl}/all`, { params });
        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async list(params = {}) {
      try {
        const response = await adminAxios.get(`${baseUrl}/list`, { params });
        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async get(id, uuid, params = {}) {
      try {
        const url = id ? `${baseUrl}/${id}` : baseUrl;
        const response = await adminAxios.get(url, { uuid, params });
        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async create(payload) {
      try {
        const response = await adminAxios.post(`${baseUrl}`, payload);
        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async update(id, uuid, payload) {
      try {
        const response = await adminAxios.put(`${baseUrl}/${id}?uuid=${uuid}`, payload);
        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async delete(id, uuid) {
      try {
        const response = await adminAxios.delete(`${baseUrl}/${id}?uuid=${uuid}`);
        return response.data.data;
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async sort(ids) {
      try {
        return await adminAxios.put(`${baseUrl}/sort`, { ids: ids });
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async changeField(id, uuid, field, value, type, payload = {}) {
      try {
        return await adminAxios.put(`${baseUrl}/${id}/field/${field}/${type}?uuid=${uuid}&${field}=${value}`, payload);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
  };
}
